export default {
    'add-new-price-type': 'إضافة نوع سعر جديد',
    'edit-price-type': 'تعديل نوع سعر',
    'this-type': 'هذا النوع '
}